function percentage(obtVal, totalVal) {
  let calPercent = (obtVal / totalVal) * 100;
  return calPercent;
}
module.exports = {
  percentage,
};
